<template>
  <div class="application" :class="['block-chain', 'section', {bgWarp: !isMobile}]">
    <div class="layout-content">
      <SubTitle :text="title" :subText="subText" />

      <div class="wrapper">
        <div
          class="content-wrapper"
          v-for="(item, index) in isMobile ? dataList.mobileList : dataList.list"
          :key="index"
        >
          <div
            class="content-list"
            v-for="(list, index) in item"
            :key="index"
            @click="playText(list.detailsText)"
          >
            <img class="content-img" :src="list.detailsText.img" alt="" />
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import SubTitle from '@/components/SubTitle.vue'
import * as GlobalLayer from '@/utils/globalLayer'

import {mapState} from 'vuex'
export default {
  name: 'block-chain',

  components: {
    SubTitle
  },

  props: {
  },

  data () {
    return {
    }
  },

  computed: {
    ...mapState(['isMobile', 'isEnLang']),
    addClassName () {
      return this.isMobile && this.isEnLang
    },
    dataList () {
      return this.$t('support').blockchain
    },
    title () {
      return this.isEnLang ? 'One-Stop Blockchain Open Source Technology Solutions' : '全栈区块链开源技术方案'
    },
    subText () {
      return this.isEnLang ? 'FINTECHATHON' : 'FINTECHATHON'
    }
  },

  created () {
  },

  methods: {
    playText (detailsText) {
      GlobalLayer.createModal(this.$store, {
        detailsText,
        isShowBtn: false
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  .application {
    padding-top: 30px;
    background: #F7F8FA;
  }

  .bgWarp {
    position: relative;
  }

  .content-warp {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 1200px;
    margin: 0 auto;
  }

  .wrapper {
  }

  .content-wrapper {
    display: flex;
    justify-content: space-between;
    margin-bottom: 46px;

    &:nth-child(1),
    &:nth-child(5),
    &:nth-child(6) {
      .content-list {
        width: 100%; height: 100%;
      }
    }

    &:nth-child(even) {
      @include mobile {
        .content-list {
          width: calc(calc(100% - 15px) / 2);
        }
      }
    }

    &:nth-child(8) {
      @include mobile {
        .content-list{
          width: 100%;
        }
      }
    }

    @include mobile {
      margin-bottom: 15px;
    }
  }

  .content-list {
    display: flex;
    width: 384px; height: 130px;
    cursor: pointer;

    @include mobile {
      width: 100%; height: 100%;
    }
  }

  .content-img {
    width: 100%; height: 100%;

    &:hover {
      opacity: 0.89;
      box-shadow: 0px 0px 5px 0px rgba(107, 107, 107, 0.32);
    }

  }

  @include mobile {
    .block-chain{
      // padding: 70px 0 10px;
    }
    .content-warp {
      box-sizing: border-box;
      width: 90vw;
    }

    .content-item {
      width: calc(100vw - 40px); height: auto;
      margin: 0 0 26px 0;

      &:nth-child(4),
      &:nth-child(5) {
        height: auto;
      }

      & .title {
        font-size: 18px;
      }

      & .tips {
        position: relative; bottom: 0;
      }

      @include enlayoutInner {
        & .title {
          font-size: 17px;
          line-height: 20px;
        }

        & .text {
          line-height: 20px;
        }
      }
    }
  }
</style>
